import * as React from "react";
import { HeadFC, graphql, navigate } from "gatsby";
import Layout from "../components/Layout";
import Banner from "../components/Entities/Banner";
import Text from "../components/Entities/Text";
import Line from "../components/Entities/Line";
import Title from "../components/Entities/Title";
import ReviewForm from "../components/ReviewForm";
import { useAuth } from "../components/Firebase/authContext";
import Reviews from "../components/Reviews";
import Youtube from "../components/Entities/Youtube";
import Facebook from "../components/Icons/Facebook";
import Instagram from "../components/Icons/Instagram";
import Share from "../components/Icons/Share";
import RatingStars from "../components/Entities/RatingStars";
import SEO from "../components/SEO";
import { useSession } from "../components/Firebase/sessionContext";
import Review from "../components/Review";
import { checkUserCommentForWorld } from "../components/Firebase/firebase";
import Icon from "../components/Entities/Icon";
import IconText from "../components/Entities/IconText";

const Page: React.FC<any> = ({ data }) => {
  const auth = useAuth();
  const { sessionData, updateSessionData } = useSession();

  const {
    title,
    fields,
    description,
    category,
    comments,
    firebaseID,
    youtube,
    createdOn,
    modifiedOn,
    maxPlayersThatCanPlay,
    creators,
    tips,
    staffReview
  } = data.allWorlds.nodes[0];
  const currentReview = sessionData.reviews?.[firebaseID] ?? null;

  React.useEffect(() => {
    const fetchData = async () => {
      const data: any = await checkUserCommentForWorld(
        firebaseID,
        currentReview ? currentReview.date : 0
      );

      if (data !== false) {
        const reviewDTO = {
          title: data.title,
          comment: data.comment,
          rating: data.rating,
          date: data.date,
        };

        reviewSend(reviewDTO);
      }
    };
    if (auth.user) fetchData();
  }, [auth]);
  const reviewSend = (message: any) => {
    const reviews = sessionData.reviews ?? {};
    reviews[firebaseID] = message;
    updateSessionData({ reviews: reviews });
  };
  const dimensionsStyle = `w-[100%]  max-w-sm sm:max-w-xl  md:max-w-3xl`;
  return (
    <Layout>
      <div className="flex w-[100%] flex-col">
        <div className="bg-black mb-10">
          <Banner
            value={{
              title: title,
              url: fields.imgSrc,
              childrenClassName:
                "bg-[#000000aa] text-white text-md md:text-4xl open-sans-bold p-4",
              className:
                "text-center flex justify-center items-center bg-cover bg-center bg-no-repeat mx-auto h-[250px] sm:h-[400px]  open-sans-normal uppercase   relative",
            }}
          >
            <div className="bg-[#000000aa] absolute bottom-0 right-0  text-white py-2 px-4 sm:px-8  flex items-center z-1 text-sm sm:text-md">
              {category}
              <span className="pl-4">•</span>
              <span className="pl-4">- / 5</span>
              <span className="pl-4">(0 review)</span>

              <RatingStars
                value={{
                  onChange: null,
                  selectedValue: 0,
                  fontSize: "text-sm sm:text-3xl",
                  className: "text-center text-xs my-2 pl-4",
                  fillColor: "#B0B3B8",
                  emptyColor: "#B0B3B8",
                }}
              />
            </div>
          </Banner>
        </div>
        <Youtube
          value={{
            id: youtube,
            className: "h-[200px] w-[100%] md:h-[300px] md:w-[600px] m-auto",
          }}
        />

        <div className="flex w-[100%]  max-w-sm  md:max-w-xl mx-auto pt-2">
          <IconText
            value={{
              tooltip: "Creator name",
              iconPosition: "left",
              className: " space-x-2",
              children: creators[0].username,
              icon: "account_circle",
            }}
          />
          <IconText
            value={{
              tooltip: "How many people at the same time",
              iconPosition: "left",
              className: "pl-4  space-x-2",
              children: "up to " + maxPlayersThatCanPlay + " players",
              icon: "diversity_3",
            }}
          />
        </div>

        <Text
          value={{
            injectedChildren: description,
            className:
              `text-secondary text-justify pt-5  ${dimensionsStyle} mx-auto open-sans-normal text-md`,
          }}
        />

        <div className="flex w-[100%] justify-between  max-w-md  md:max-w-lg mx-auto px-2 pt-5">
          {/**/}
          <IconText
            value={{
              tooltip: "Creation date",
              iconPosition: "top",
              className: "w-[140px]",
              children: "Confortable",
              icon: "track_changes",
              textClassName: "",
            }}
          />
          <IconText
            value={{
              tooltip: "Creation date",
              iconPosition: "top",
              className: "w-[140px]",
              children: createdOn,
              icon: "calendar_month",
              textClassName: "",
            }}
          />
          <IconText
            value={{
              tooltip: "Last update",
              iconPosition: "top",
              className: "w-[140px]",
              children: modifiedOn,
              icon: "history",
              textClassName: "",
            }}
          />
        </div>

        <div className={`flex flex-col  justify-center ${dimensionsStyle} mx-auto p-10 border border-secondary  rounded mt-5`}>
          <Title
            value={{
              children: "Creators",
              type: "h2",
              className: "text-center text-secondary open-sans-normal pb-5",
            }}
          />
          <div
            className={`text-left text-white grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3`}
          >
            {creators.map((creator: any, index: number) => (
              <div className="flex w-[150px]  py-2">
                <Icon
                  value={{
                    iconPosition: "left",
                    icon: "account_circle",
                    className: "text-secondary text-4xl",
                  }}
                />
                <div className="pl-5">
                  <Text value={{ injectedChildren: creator.username, className: "text-secondary open-sans-normal" }} />
                  <Text value={{ injectedChildren: creator.role, className: "text-xs text-black open-sans-normal" }} />
                </div>
              </div>
            ))}
          </div>
        </div>
          {tips.length > 0 && tips[0].title !== "" ? (
        <div className="flex flex-col w-[100%] justify-center   mx-auto px-2 bg-black mt-10 p-10">
          <Title
            value={{
              children: "Tips and tricks",
              type: "h2",
              className: "text-center text-secondary open-sans-normal  py-2",
            }}
          />
          <div className="text-left text-white grid grid-cols-1 max-w-4xl w-[100%] mx-auto ">
            <div className="">
              {tips.map((tip: any, index: number) => (
                <div className="flex max-w-xl mx-auto py-2 justify-center">
                  <Icon
                    value={{
                      iconPosition: "left",
                      icon: "lightbulb_outline",
                      className: "text-secondary text-5xl",
                    }}
                  />
                  <div className="pl-5">
                    <Text value={{ injectedChildren: tip.title, className: "text-secondary text-md  open-sans-semibold" }} />
                    <Text value={{ injectedChildren: tip.description, className: "text-sm open-sans-normal" }} />
                  </div>
                </div>
              ))}
            </div>
           
          </div>
        </div>
        ): null}

        {/*<div className="flex mx-auto max-w-[200px] w-[100%] justify-between items-center">
          <Facebook />
          <Instagram />
          <Share />
        </div>*/}
        {/*<Line value={{ className: "mt-5" }} />*/}
        <Title
          value={{
            children: "Comments",
            type: "h2",
            className: "text-center text-secondary open-sans-normal my-5",
          }}
        />
        {currentReview ? (
          <Review review={currentReview} />
        ) : (
          <ReviewForm
            idWorld={firebaseID}
            auth={auth?.user}
            reviewSend={reviewSend}
          />
        )}
        {staffReview.title !== '' ? <Review review={{...staffReview, isAdmin:true}} /> : null}
        <Reviews comments={comments} />
      </div>
    </Layout>
  );
};

export default Page;

export const Head: HeadFC = ({ location, params, data, pageContext }: any) => {
  const { title, fields, description } = data.allWorlds.nodes[0];
  return (
    <SEO
      props={{
        title: `VRWorldSpace - ${title}`,
        description: description,
        image: fields.imgSrc,
        url: location.pathname,
        type: "article",
      }}
    />
  );
};

export const WorldTemplateQuery = graphql`
  query GetWorlds($id: String!) {
    allWorlds(filter: { id: { eq: $id } }) {
      nodes {
        firebaseID
        youtube
        id
        title
        bannerImage
        fields {
          imgSrc
        }
        category
        description
        createdOn
        modifiedOn
        maxPlayersThatCanPlay
        creators {
          role
          username
        }
        tips {
          title
          description
        }
        staffReview {
          author
          comment
          date
          rating
          title
        }
      }
    }
  }
`;
/*

      comments {
          title
          comment
          username
          rating
        }

        */
